import axios from 'axios'
import store from '../store'
import {cks} from './tool'
import { BASE_API } from './global'

// 创建axios实例
const service = axios.create({
    baseURL: BASE_API,
    timeout: 70000,                // 请求超时时间
    headers: {'Content-Type': 'text/plain'}
})

// request拦截器
service.interceptors.request.use(config => {
    const token = cks.get('token')
    const app_version = "w_1.0" // web版本以w开头
    if (config.method === 'post') {
        if (!config.data) {
            config.data = {}
        }
        if (!config.data['token']) {
            config.data['token'] = token
        }
        config.data['app_version'] = app_version
    } else if (config.method === 'get') {
        if (!config.params) {
            config.params = {}
        }
        if (!config.params['token']) {
            config.params['token'] = token
        }
        config.params['app_version'] = app_version
    }
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code === 200) {
            return res
        } else if (res.code === 412) {
            store.dispatch("setToken", "");
            location.reload()
        } else {
            return Promise.reject({code: res.code, message: res.message, data: res.data})
        }
    },
    error => {
        console.log('err' + error)// for debug
        return Promise.reject({message: 'Network error', code: 500})
    }
)

export default service
